import React from 'react';
import {sortTable} from "../../constant";
import {BiSort} from "react-icons/bi";
import {CFormCheck, CImage} from "@coreui/react-pro";
import FailIcon from "../../assets/icons/assessment-fail-icon.png";
import PassIcon from "../../assets/icons/assessment-pass-icon.png";
import Table from "../tables/table";
import {FaEdit, FaTrashAlt} from "react-icons/fa";


function AttendanceTable({headers, items, setPageTap}) {
    return (
        <Table headers={headers}>
            {items?.map((item, index) => (
                <tr className="cursor-pointer bg-white border"
                    key={index}
                    onClick={() => setPageTap(1)}
                >
                    <td className="td-single-line fw-light">{item?.name}</td>
                    <td className="fw-light">{item?.course}</td>
                    <td className="fw-light">{item?.clockIn}</td>
                    <td className="fw-light text-danger">{item?.clockOut}</td>
                    <td className="fw-light">{item?.totalHours}</td>
                    <td className="fw-light">
                        <div className="d-flex align-items-center h-100 mt-3"><small
                            className={`border ${item?.status == "Absent" && "border-danger"}  ${item?.status == "Present" && "border-primary"} justify-content-center align-items-center d-flex`}
                            style={{width: '70px', height: '20px'}}>{item?.status}</small></div>
                    </td>
                    <td className="fw-light">
                        <div className="d-flex align-items-center gap-3">
                            <div><FaTrashAlt className="text-danger" size={15}/></div>
                            <div><FaEdit className="text-black-50" size={15}/></div>
                        </div>
                    </td>
                </tr>
            ))}
        </Table>
    );
}

export default AttendanceTable;
